import { useSelector, useDispatch } from 'react-redux'
import { resetSnackbar } from '../../redux/snackbar'
import { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { stepReset, stepIncrement, stepDecrement } from '../../redux/steps'
import { USER_STATUS } from '../../const'
import { Snackbar } from '../../components'
import { StepOne } from '../../components/NewCaseSteps/StepOne'
import { NewPatientStepper } from '../../components/NewPatientStepper'
import { PatientDataForm } from '../../components/PatientDataForm'
import { PatientSuccess } from '../../components/PatientSuccess'
import { Container } from './styles'

export function NewPatient () {
  const { steps, snackbar, user } = useSelector(state => state)
  const dispatch = useDispatch()
  const [isCompleted, setIsCompleted] = useState(false)

  // Only allow technicians to access this route
  if (user.status === USER_STATUS.LOCKED || user.role !== 'technical') {
    return <Redirect to='/home' />
  }

  const handleCloseSnackbar = () => {
    dispatch(resetSnackbar())
  }

  // Reset steps when component mounts
  useEffect(() => {
    dispatch(stepReset())
  }, [])

  const handleNextStep = () => {
    dispatch(stepIncrement())
  }

  const handlePreviousStep = () => {
    if (steps.current > 1) {
      dispatch(stepDecrement())
    }
  }

  const handleSuccess = () => {
    setIsCompleted(true)
  }

  const handleNewPatient = () => {
    setIsCompleted(false)
  }

  const renderCurrentStep = () => {
    if (isCompleted) {
      return <PatientSuccess onNewPatient={handleNewPatient} />
    }

    switch (steps.current) {
      case 1:
        return <StepOne />
      case 2:
        return <PatientDataForm backStep={handlePreviousStep} onSuccess={handleSuccess} />
      default:
        return <div>Error: Paso no encontrado</div>
    }
  }

  return (
    <Container>
      {snackbar.active && (
        <Snackbar status={snackbar.status} close={handleCloseSnackbar}>
          {snackbar.text}
        </Snackbar>
      )}

      {!isCompleted && <NewPatientStepper />}
      {renderCurrentStep()}
    </Container>
  )
}

export default NewPatient
